import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Transformer, Group, Rect } from 'react-konva';
import styles from './SketchLabelGroup.styles';
import SketchLabel from '../SketchLabel';

const useStyles = makeStyles(styles);

// const SketchLabelGroup = ({ draggable, onDragEnd, x, y, scaleX, scaleY, onSelect, onTransformEnd, children }) => {
const SketchLabelGroup = ({ shapeProps, isSelected, onSelect, onTransformEnd, children }) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();

  useEffect(() => {
    if (isSelected) {
      // we need to attach transformer manually
      trRef.current.setNode(shapeRef.current);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  return (
    <React.Fragment>
      <Group
        onClick={onSelect}
        ref={shapeRef}
        {...shapeProps}
        draggable
        onTransformEnd={e => {
          // transformer is changing scale of the node
          // and NOT its width or height
          // but in the store we have only width and height
          // to match the data better we will reset scale on transform end
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          const rotation = node.rotation();

          onTransformEnd({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            rotation,
            scaleX,
            scaleY,
            // set minimal value
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY),
          });
        }}
      >
        {/* <Rect {...shapeProps} fill="blue" width={200} height={100} /> */}
        {children}
      </Group>
      {isSelected && (
        <Transformer
          draggable
          ref={trRef}
          // resizeEnabled={false}
          rotationSnaps={[0, 45, 90, 135, 180, 225, 270, 315]}
          // boundBoxFunc={(oldBox, newBox) => {
          //   // limit resize
          //   if (newBox.width < 5 || newBox.height < 5) {
          //     return oldBox;
          //   }
          //   return newBox;
          // }}
        />
      )}
    </React.Fragment>
  );
};

SketchLabelGroup.defaultProps = {};
SketchLabelGroup.propTypes = {
  // x: PropTypes.number,
  // y: PropTypes.number,
  // text: PropTypes.string,
  // rotation: PropTypes.number,
};

export default SketchLabelGroup;
